import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.css']
})
export class StaffComponent implements OnInit {

  model = {
    'table_name': 'staff', 'staff_id': '0', 'staff_name': '', 'staff_name_en': '',
    'gender': '', 'staff_mobile1': '', 'staff_mobile2': '', 'comment': ''
  };

  Success_Msg; Error_Msg; Name_Msg; Mobile_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<StaffComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Name_Msg').subscribe((res: string) => {
      this.Name_Msg = res;
    });

    translate.get('Mobile_Msg').subscribe((res: string) => {
      this.Mobile_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['staff_name'] != '' && this.model['staff_mobile1'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['staff_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'staff_id': this.model['staff_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['staff_name'] == '') {
      alert(this.Name_Msg);
    }

    else if (this.model['staff_mobile1'] == '') {
      alert(this.Mobile_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
